import { Fallback, Image, Root as AvatarRoot } from "@radix-ui/react-avatar";

import { Check24 } from "@/components/ui/SvgIcon";

import cn from "@/utils/cn";

type Props = {
  name: string;
  image?: string;
  className?: string;
  checked?: boolean;
};

export const Avatar = ({
  name,
  image,
  checked,
  className,
  ...props
}: Props) => {
  const fallback = name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase())
    .slice(0, 1)
    .join("");

  return (
    <AvatarRoot
      className={cn(
        "relative flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full border border-chorus-teal-200 bg-chorus-teal-200 font-sora text-md font-medium tracking-[-0.16px] text-chorus-teal-600 md:border-chorus-black-100 md:bg-chorus-black-100 md:text-chorus-gray-400",
        className,
      )}
      {...props}
      data-testid="avatar"
    >
      <Image src={image} data-testid="avatar-image" />
      <Fallback>{fallback}</Fallback>
      {checked && (
        <div className="absolute left-0 top-0 z-50 flex size-10 items-center justify-center bg-chorus-teal-200 md:bg-chorus-black-100">
          <Check24 data-testid="avatar-icon" className="fill-current" />
        </div>
      )}
    </AvatarRoot>
  );
};

Avatar.displayName = "Avatar";
